<template>
  <div style="width: 100%; text-indent:20px">
    <span>{{ params.displayName }}</span>
    <i class="el-icon-question" :title="params.title" />
  </div>
</template>

<script>

import Vue from 'vue'
export default Vue.extend({
  name: 'CustomizationAgGridHeader'
})
</script>

<style scoped>

</style>
